import { Box, Typography, IconButton, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useSelector } from "react-redux";
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X';
import TikTokIcon from '../../common/TikTokIcon';

const SocialMedia = ({ user, profile }) => {
  // A quién se sigue, por su nombre (antes decía el rol de su perfil: «Sigue el trabajo de Diseñadora de interiores en sus redes»)
  const nombre = String(user?.name || '').trim();
  const authUser = useSelector(state => state.user.user);
  const esMiPerfil = Boolean(authUser?._id) && String(authUser._id) === String(user?._id);

  const getSocialLink = (id, username) => {
    const valor = String(username || '').trim();
    if (!valor) return null;
    if (valor.startsWith('http')) return valor;

    // Remove @ if user included it
    const cleanUsername = valor.startsWith('@') ? valor.slice(1) : valor;

    const baseUrls = {
      instagram: 'https://instagram.com/',
      facebook: 'https://facebook.com/',
      tiktok: 'https://tiktok.com/@',
      youtube: 'https://youtube.com/@',
      twitter: 'https://x.com/',
      linkedin: 'https://linkedin.com/in/'
    };

    return baseUrls[id] ? `${baseUrls[id]}${cleanUsername}` : `https://${valor}`;
  };

  // Solo las que tiene: antes salían las seis y las que no tiene en gris, como botones que no hacían nada
  const redes = [
    { key: 'instagram', nombre: 'Instagram', icon: <InstagramIcon />, url: getSocialLink('instagram', profile?.redes?.instagram) },
    { key: 'facebook', nombre: 'Facebook', icon: <FacebookIcon />, url: getSocialLink('facebook', profile?.redes?.facebook) },
    { key: 'tiktok', nombre: 'TikTok', icon: <TikTokIcon />, url: getSocialLink('tiktok', profile?.redes?.tiktok) },
    { key: 'youtube', nombre: 'YouTube', icon: <YouTubeIcon />, url: getSocialLink('youtube', profile?.redes?.youtube) },
    { key: 'twitter', nombre: 'X', icon: <XIcon />, url: getSocialLink('twitter', profile?.redes?.twitter) },
    { key: 'linkedin', nombre: 'LinkedIn', icon: <LinkedInIcon />, url: getSocialLink('linkedin', profile?.redes?.linkedin) },
  ].filter(red => red.url);

  // Sin redes, quien visita no ve la sección; la persona, en su propio perfil, ve dónde agregarlas
  if (redes.length === 0 && !esMiPerfil) return null;

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h5" sx={{ fontWeight: 700, color: 'primary.main', mb: 0.5 }}>
        Redes sociales
      </Typography>
      {redes.length === 0 ? (
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
          Aún no agregas tus redes. <Link component={RouterLink} to="/mi-perfil">Agrégalas en tu perfil</Link>, en «Redes sociales»,
          para que tus clientes puedan seguir tu trabajo.
        </Typography>
      ) : (
        <>
          <Typography variant="body2" sx={{ color: 'text.secondary', display: 'block', mb: 3 }}>
            {nombre ? `Sigue el trabajo de ${nombre} en sus redes` : 'Sigue su trabajo en redes'}
          </Typography>

          <Box sx={{ display: 'flex', gap: 1.25, flexWrap: 'wrap' }}>
            {redes.map((red) => (
              <IconButton
                key={red.key}
                component="a"
                href={red.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={red.nombre}
                sx={{
                  bgcolor: 'white',
                  boxShadow: '0px 4px 10px rgba(0,0,0,0.05)',
                  width: 44,
                  height: 44,
                  color: 'primary.main',
                  '&:hover': {
                    bgcolor: 'action.hover',
                    transform: 'translateY(-2px)',
                  },
                  transition: 'all 0.2s',
                }}
              >
                {red.icon}
              </IconButton>
            ))}
          </Box>
        </>
      )}
    </Box>
  );
};

export default SocialMedia;
